import request from '@/utils/request'; // 服务名：ecargoprotocol

export var BASE = '/api';
export var BASE_PATH = '/ecargoprotocol'; // 产品配置维护数据

export function importedColdChain_queryPage(data) {
  return request({
    url: '/ecargoprotocol/importedColdChain/queryPage',
    method: 'post',
    data: data
  });
}
export function importedColdChain_delete(data) {
  return request({
    url: '/ecargoprotocol/insure/Delete',
    method: 'post',
    data: data
  });
} // TODO 申报记录数据

export function declarationRecordQueryPage(data) {
  return request({
    url: '/ecargoprotocol/coldChain/findList',
    method: 'post',
    data: data
  });
} // TODO 手动定时任务

export function declarationSD(data) {
  return request({
    url: '/ecargoprotocol/coldChain/getCustomsNo',
    method: 'post',
    data: data
  });
} // TODO 自动定时任务

export function autoDeclare(data) {
  return request({
    url: '/ecargoprotocol/coldChain/autoDeclare',
    method: 'post',
    data: data
  });
} // TODO 投保申请导出

export function listTouBaoDc(data) {
  return request({
    url: '/ecargoprotocol/importedColdChain/exportExcelDc',
    method: 'post',
    data: data,
    responseType: 'arraybuffer'
  });
} // TODO 货物申报记录清单导出

export function decalarListDC(data) {
  return request({
    url: '/ecargoprotocol/importedColdChain/declarationDc',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
} // TODO 货物申报结算清单导出

export function cargoDeclareDC(data) {
  return request({
    url: '/ecargoprotocol/importedColdChain/cargoDc',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
} // TODO 协议清单导出

export function protocolWarrantyDc(data) {
  return request({
    url: '/ecargoprotocol/importedColdChain/protocolDc',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
} // TODO 货运险导出

export function countCargoInsuranceDc(data) {
  return request({
    url: '/ecargoprotocol/importedColdChain/countCargoInsurance',
    method: 'post',
    data: data
  });
}
export function cargoInsuranceDc(data) {
  return request({
    url: '/ecargoprotocol/importedColdChain/cargoInsurance',
    method: 'post',
    data: data,
    responseType: 'blob'
  });
} // TODO 申报记录详情

export function declarationRecordDetail(data) {
  return request({
    url: '/ecargoprotocol/coldChain/findOne',
    method: 'post',
    data: data
  });
}
export function queryCargoDeclareBalanceRecord(data) {
  return request({
    url: '/ecargoprotocol/tApplicationProtocol/queryCargoDeclareBalanceRecord',
    method: 'post',
    data: data
  });
}
export function updateDeclareSettleStatus(data) {
  return request({
    url: '/ecargoprotocol/coldChain/updateDeclareSettleStatus',
    method: 'post',
    data: data
  });
}